import React, { useState } from 'react';
import './BlockchainRegistry.css';

const BlockchainRegistry = ({ onNext }) => {
  const [notes, setNotes] = useState('');

  const handleProceed = () => {
    alert('✅ Proceeding to tokenization...');
    if (onNext) {
      onNext();
    }
  };

  return (
    <div className="blockchain-registry">
      <header className="blockchain-header">
        <h1>Blockchain Registry</h1>
        <p>Immutable Carbon Credit Ledger</p>
      </header>

      <div className="blockchain-container">
        {/* Registration Status */}
        <section className="blockchain-section">
          <div className="blockchain-section-header">Registration Status</div>
          <div className="status-grid">
            <div className="status-item">
              <span>Status:</span>
              <strong className="status-registered">Registered</strong>
            </div>
            <div className="status-item">
              <span>Block Number:</span>
              <strong>12,345,678</strong>
            </div>
            <div className="status-item">
              <span>Timestamp:</span>
              <strong>2023-10-15 14:30:22 UTC</strong>
            </div>
          </div>
        </section>

        {/* Credit Details */}
        <section className="blockchain-section">
          <div className="blockchain-section-header">Credit Details</div>
          <div className="details-grid">
            <div className="detail-item">
              <span>Credit Amount:</span>
              <strong>2.3 tons CO₂</strong>
            </div>
            <div className="detail-item">
              <span>Project Area:</span>
              <strong>1.2 hectares</strong>
            </div>
            <div className="detail-item">
              <span>Vintage Year:</span>
              <strong>2023</strong>
            </div>
            <div className="detail-item">
              <span>Verification Date:</span>
              <strong>15/10/2023</strong>
            </div>
          </div>
        </section>

        {/* Transaction Hash */}
        <section className="blockchain-section">
          <div className="blockchain-section-header">Transaction Hash</div>
          <div className="hash-container">
            <code className="hash-code">
              0x7a3f9b2c8e1d4f6a5b9c3e7d2a8f1b4c6e9d3a7f2b5c8e1d4a7b9c3e6f2a5b8c
            </code>
          </div>
        </section>

        {/* Smart Contract */}
        <section className="blockchain-section">
          <div className="blockchain-section-header">Smart Contract</div>
          <div className="contract-info">
            <div className="contract-item">
              <span>Contract Address:</span>
              <code>0xABC123...DEF789</code>
            </div>
            <div className="contract-item">
              <span>Network:</span>
              <strong>Aptos Mainnet</strong>
            </div>
            <div className="contract-item">
              <span>Token Standard:</span>
              <strong>APT-20</strong>
            </div>
          </div>
        </section>

        {/* Audit Trail */}
        <section className="blockchain-section">
          <div className="blockchain-section-header">Audit Trail</div>
          <div className="audit-list">
            <div className="audit-item">
              <span className="audit-icon">✓</span>
              <span>Initial assessment completed</span>
            </div>
            <div className="audit-item">
              <span className="audit-icon">✓</span>
              <span>Satellite analysis verified</span>
            </div>
            <div className="audit-item">
              <span className="audit-icon">✓</span>
              <span>Expert verification approved</span>
            </div>
            <div className="audit-item">
              <span className="audit-icon">✓</span>
              <span>Third-party compliance confirmed</span>
            </div>
            <div className="audit-item">
              <span className="audit-icon">✓</span>
              <span>Blockchain registration complete</span>
            </div>
          </div>
        </section>

        {/* Registry Notes */}
        <section className="blockchain-section">
          <div className="blockchain-section-header">Registry Notes</div>
          <textarea
            className="blockchain-textarea"
            placeholder="Add any additional notes or observations..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </section>

        {/* Action Button */}
        <div className="blockchain-actions">
          <button className="blockchain-btn proceed-btn" onClick={handleProceed}>
            Proceed to Tokenization
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockchainRegistry;
